import { atom } from 'recoil';

export const agentOptions = atom({
  key: 'agentOptions', // unique ID (with respect to other atoms/selectors)
  default: {
    chart: {
      height: 650,
      type: 'bar',
    },
    title: {
      text: 'Agent Summary',
    },
    xAxis: {
      categories: [],
      alignTicks: true,
    },
    yAxis: {
      labels: {
        enabled: true,
      },
      title: {
        text: '',
      },
    },
    plotOptions: {
      series: {
        animation: {
          duration: 1750,
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: '',
        data: [],
        showInLegend: false,
      },
    ],
  },
  // default value (aka initial value)
});
